import './featured-list.scss';

import { Component, Vue } from 'vue-property-decorator';

import { Featured, FeaturedCard } from '../featured-card';

@Component({
    components: {
        sFeaturedCard: FeaturedCard,
    },
    props: ['emptyMessage', 'featureds', 'title'],
    template: require('./featured-list.html'),
})
export class FeaturedList extends Vue {
    public emptyMessage: string;
    public featureds: Featured[];
    public title: string;
}
